<template>
  <div class="section-container">
    <div class="d-flex justify-space-between">
      <header-title-two
        :loading="isLoading"
        title="Methodology Quick Guides"
        loaderClass="mb-lg-4"
      />
      <template v-if="methodGuides.length > 0">
        <previous-next-navigation
          :navIndex="methodGuidesSlide"
          :navLast="methodGuides.length - numberOfSlides"
          v-on:on-prev="onNav('prev')"
          v-on:on-next="onNav('next')"
          class-name="align-center prev-nav justify-end"
        />
      </template>
    </div>
    <skeleton-card-list
      type="avatar"
      :loading="isLoading"
      :isCard="true"
      :number="numberOfSlides"
      direction="horizontal"
      class="mt-4 skeleton-methodology flex-nowrap flex-lg-wrap"
    >
      <div class="content">
        <slick-carousel
          v-if="methodGuides.length > 0"
          ref="slickCarousel"
          :itemsToShow="numberOfSlides"
          :settings="slickSettings"
          @afterChange="afterChange"
        >
          <card-two
            v-for="item in methodGuides"
            v-bind:key="item.id"
            :id="item.id"
            :title="item.title"
            :description="item.description"
            :file="item.url"
          />
        </slick-carousel>
      </div>
    </skeleton-card-list>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MethodGuidesApi } from '@gslc/models';
import { openApiConfig } from '../../api/config';
import HeaderTitleTwo from '../../components/typography/header-title-2.vue';
import PreviousNextNavigation from '../../components/PreviousNextNavigation.vue';
import SkeletonCardList from '../../components/skeleton/CardList.vue';
import CardTwo from '../../components/cards/card-2.vue';
import SlickCarousel from '../../components/carousel/SlickCarousel.vue';
import { defaultSlickSettings, getNumberOfSlides } from '../../utils/carousel';

const config = openApiConfig();

const methodGuidesApi = new MethodGuidesApi(config);
export default {
  components: {
    HeaderTitleTwo,
    PreviousNextNavigation,
    SkeletonCardList,
    CardTwo,
    SlickCarousel,
  },
  data: () => ({
    isLoading: false,
    methodGuidesSlide: 0,
    slickSettings: defaultSlickSettings([3, 3.5, 2, 2, 1.2]),
  }),
  computed: {
    ...mapGetters(['methodGuides', 'windowWidth']),
    numberOfSlides () {
      return getNumberOfSlides(this.windowWidth, [1.2, 2, 2, 3.5, 3]);
    }
  },
  mounted() {
    this.fetchMethodGuides();
  },
  methods: {
    ...mapActions(['refreshMethodGuides']),
    async fetchMethodGuides() {
      this.isLoading = true;
      const accessToken = await this.$auth.getTokenSilently();
      const methodGuides = await methodGuidesApi
        .getMethodologyQuickGuides({
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .catch(e => console.error(e));
      this.refreshMethodGuides(methodGuides?.data?.data ?? []);
      this.isLoading = false;
    },
    afterChange(slideNumber) {
      this.methodGuidesSlide = slideNumber;
    },
    onNav(type) {
      switch (type) {
        case 'prev':
          this.$refs.slickCarousel.$children[0].prev();
          break;
        case 'next':
        default:
          this.$refs.slickCarousel.$children[0].next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  overflow: auto;
  width: calc(100% + 8px);
}
</style>
